import { render, staticRenderFns } from "./orderLink.vue?vue&type=template&id=64681e50&"
import script from "./orderLink.vue?vue&type=script&lang=js&"
export * from "./orderLink.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports